// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_RATINGS = ["%(counter)s hodnotenie", "%(counter)s hodnotenia", "%(counter)s hodnoten\u00ed"];
export const PRODUCT_BOX_WRITE_REVIEW = "Nap\u00ed\u0161 hodnotenie";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prv\u00e1 a nap\u00ed\u0161 hodnotenie";
